export default {
  deviceRow1: 'Device mate通过开发新的应用以提供解决生产中的计划、执行、质量和交期等问题的新思路和新方法，从而揭示设备黑盒子状态；是第一个云端配置，边缘部署的工业物联网应用软件。Device Mate就是要建立设备的数字化模型，揭示设备内部的工作过程，实时获取设备运行状态（OEE）。在此基础上，结合数字化工艺和数字产线引擎以及数字化质量，形成透明的数字化制造模型；',
  deviceRow2: '配置不同物理设备的数字孪生，通过定义设备之间的关系来创建产线的数字孪生；',
  deviceRow3: '在边缘端使用IPC来处理数据，实现在近设备端运行应用；',
  deviceRow4: '云端创建、配置和更新应用程序，并自动部署到边缘端，可不停机升级应用，实现改进；',
  deviceRow5: '应用部署到边缘端之前，可结合边缘端配置在云端对应用性能、连接和存储进行模拟，以解决潜在问题，保证部署、运行的安全，确保不影响生产；'
}
